<div class="door-dialog-container" [style.--device-cols]="displayCols">
  <!-- Header -->
  <div class="dialog-header">
    <h2 mat-dialog-title class="dialog-title">
      {{ 'records.openDoor' | translate }}
    </h2>
    <button mat-icon-button mat-dialog-close class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div mat-dialog-content class="dialog-content">
    <div *ngIf="devices.length > 0; else noDevices" class="devices-container">
      <div class="devices-grid">
        <mat-card
          *ngFor="let device of devices"
          class="device-card"
          [class.device-card--loading]="device.id && loadingDevices.includes(device.id)"
        >
          <div class="device-head">
            <span class="device-icon-chip">
              <mat-icon>meeting_room</mat-icon>
            </span>
            <span class="device-name" [title]="device.name">{{ device.name }}</span>
          </div>

          <button
            mat-raised-button
            color="primary"
            class="open-door-button"
            (click)="openDoor(device.id!)"
            [disabled]="!device.id || loadingDevices.includes(device.id)"
          >
            <mat-icon *ngIf="!device.id || !loadingDevices.includes(device.id)"
              >lock_open</mat-icon
            >
            <mat-spinner
              *ngIf="device.id && loadingDevices.includes(device.id)"
              diameter="18"
            ></mat-spinner>
            <span>{{ 'records.openDoor' | translate }}</span>
          </button>
        </mat-card>
      </div>
    </div>

    <ng-template #noDevices>
      <div class="no-devices-container">
        <mat-icon class="no-devices-icon">device_hub_off</mat-icon>
        <h3 class="no-devices-title">{{ 'records.noDevicesFound' | translate }}</h3>
        <p class="no-devices-description">
          {{ 'records.noDevicesDescription' | translate }}
        </p>
      </div>
    </ng-template>
  </div>

  <!-- Footer -->
  <div mat-dialog-actions class="dialog-actions">
    <button mat-button mat-dialog-close class="cancel-button">
      <span [translate]="'entity.action.cancel'">Cancel</span>
    </button>
  </div>
</div>
